import Backbone from "extensions/backbone";

import { PazienRouter } from "common/routers/pazienRouter";

export const MerchantRouter = PazienRouter.extend({
    initialize() {
        this.listenTo(Backbone.history, "routeNotFound", this.onRouteNotFound);
    },
    
    onRouteNotFound() {
        Backbone.history.navigate("login", { trigger: true });
    },
    
    appRoutes: {
        insufficient_privileges: {
            method: "insufficient_privileges",
            ensureAuth: true
        },
        "(/)": {
            method: "main",
            ensureAuth: false
        },
        "administrator(/)": {
            redirect: "administrator/credentials"
        }
    }
});
